import React from "react";
import { useNavigate } from "react-router-dom";
import {
  CAccordion,
  CAccordionBody,
  CAccordionHeader,
  CAccordionItem,
  CButton,
  CContainer,
} from "@coreui/react-pro";
import PublicContentPageShell from "../../components/public/PublicContentPageShell";
import "../../styles/public-experience.css";
import "../../styles/public-family-alignment.css";

const updateDate = "21.03.2026";

const legalBasisItems = [
  {
    title: "Art. 6 Abs. 1 lit. b DSGVO",
    text: "wenn die Verarbeitung zur Anbahnung oder Erfüllung eines Vertrags oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist.",
  },
  {
    title: "Art. 6 Abs. 1 lit. c DSGVO",
    text: "wenn wir einer rechtlichen Verpflichtung unterliegen, etwa handels-, steuer- oder aufsichtsrechtlichen Aufbewahrungspflichten.",
  },
  {
    title: "Art. 6 Abs. 1 lit. f DSGVO",
    text: "wenn die Verarbeitung zur Wahrung unserer berechtigten Interessen erforderlich ist, zum Beispiel für den sicheren Betrieb, Missbrauchsprävention, Produktverbesserung und nachvollziehbare interne Abläufe.",
  },
  {
    title: "Art. 9 Abs. 2 DSGVO",
    text: "soweit aus Bewerbungs-, Nachweis- oder Ausweisdokumenten besondere Kategorien personenbezogener Daten hervorgehen und deren Verarbeitung im konkreten Einzelfall erforderlich ist oder von Ihnen selbst veranlasst wird.",
  },
];

const sections = [
  {
    title: "1. Verantwortlicher",
    content: (
      <>
        <p>
          Verantwortlich für die Verarbeitung personenbezogener Daten im Zusammenhang mit der Website,
          dem Funnel, den Applicant-, Employer- und Admin-Bereichen sowie den damit verbundenen Services ist:
        </p>
        <address className="public-legal-address">
          <strong>Experts4Europe GmbH in Gründung</strong>
          <span>Kirchgasse 37</span>
          <span>9853 Gmünd in Kärnten</span>
          <span>Österreich</span>
        </address>
        <p>Vertretungsberechtigt: Markus Diehl, geschäftsführender Gesellschafter</p>
        <p>
          Datenschutzanfragen können Sie jederzeit an{" "}
          <a href="mailto:Info@Experts4Europe.com">Info@Experts4Europe.com</a> richten.
        </p>
      </>
    ),
  },
  {
    title: "2. Wofür diese Datenschutzerklärung gilt",
    content: (
      <>
        <p>Diese Datenschutzerklärung gilt insbesondere für folgende Angebote von Experts4Europe:</p>
        <ul>
          <li>die öffentliche Website von Experts4Europe,</li>
          <li>den Bewerber- und Arbeitgeberbereich,</li>
          <li>administrative und interne Verwaltungsoberflächen,</li>
          <li>den Funnel experts4germany.com zur Frühanmeldung qualifizierter Pflegefachkräfte,</li>
          <li>digitale Sprach- und Qualifizierungsstrecken, insbesondere den Deutsch-/B1-Bereich,</li>
          <li>Kommunikations-, Matching-, Filing-, KVP- und Supportfunktionen,</li>
          <li>KI-gestützte Assistenzfunktionen, soweit sie in den genannten Angeboten eingebunden sind.</li>
        </ul>
        <p>
          Der Funnel dient ausschließlich der Früherfassung und Vorqualifizierung. Dort werden keine
          Dokumente hochgeladen. Dokumentenverarbeitung beginnt erst später im direkten Dialog innerhalb
          der Hauptplattform.
        </p>
      </>
    ),
  },
  {
    title: "3. Besuch der Website und Server-Logdaten",
    content: (
      <>
        <p>
          Beim Aufruf unserer Seiten verarbeiten wir technisch erforderliche Verbindungs- und Logdaten,
          zum Beispiel IP-Adresse, Datum und Uhrzeit des Abrufs, angeforderte Ressource, Referrer, Browser-
          und Geräteinformationen, übertragene Datenmenge sowie den HTTP-Status.
        </p>
        <p>
          Diese Verarbeitung erfolgt zur sicheren Bereitstellung der Website, zur Fehleranalyse, zur
          Stabilität des Betriebs sowie zur Abwehr von Missbrauch und Angriffen. Rechtsgrundlage ist
          Art. 6 Abs. 1 lit. f DSGVO.
        </p>
      </>
    ),
  },
  {
    title: "4. Kontaktaufnahme, Support und Kommunikation",
    content: (
      <>
        <p>
          Wenn Sie uns per E-Mail, über Kontaktstrecken, Support, Formular oder im Rahmen der
          Frühanmeldung kontaktieren, verarbeiten wir die von Ihnen mitgeteilten Daten zur Bearbeitung
          Ihrer Anfrage und zur weiteren Kommunikation.
        </p>
        <p>Je nach Fall können insbesondere folgende Daten verarbeitet werden:</p>
        <ul>
          <li>Name, E-Mail-Adresse, Mobilnummer oder WhatsApp-Kontakt,</li>
          <li>Herkunftsland, Kommunikationssprache und gewünschter Zielmarkt,</li>
          <li>Ihre Mitteilungen, Rückfragen, Termin- und Follow-up-Informationen,</li>
          <li>funnel- oder plattformbezogene Statusinformationen.</li>
        </ul>
        <p>
          Die Verarbeitung erfolgt zur Bearbeitung Ihrer Anfrage, zur vorvertraglichen Kommunikation und
          zur geordneten Betreuung unserer Interessenten, Nutzer und Kunden auf Grundlage von Art. 6
          Abs. 1 lit. b und lit. f DSGVO.
        </p>
      </>
    ),
  },
  {
    title: "5. Registrierung, Login und Sitzungsverwaltung",
    content: (
      <>
        <p>
          Für Applicant-, Employer- und Admin-Bereiche verarbeiten wir Registrierungs-, Authentifizierungs-
          und Sitzungsdaten, damit Nutzerkonten angelegt, Rollen zugewiesen, Zugriffe geschützt und aktive
          Sitzungen verwaltet werden können.
        </p>
        <ul>
          <li>Kontaktdaten und Zugangsdaten bei Registrierung und Login,</li>
          <li>Rolle, Benutzerkennung und Statusinformationen des Kontos,</li>
          <li>Sitzungsinformationen, Sicherheitsereignisse und Logout-/Widerrufsereignisse,</li>
          <li>technisch erforderliche Speicherungen in Browser- oder Gerätespeichern, soweit sie für den Betrieb notwendig sind.</li>
        </ul>
        <p>
          Rechtsgrundlagen sind Art. 6 Abs. 1 lit. b DSGVO für die Nutzung des Kontos sowie Art. 6
          Abs. 1 lit. f DSGVO für IT-Sicherheit, Missbrauchserkennung und den stabilen Betrieb.
        </p>
      </>
    ),
  },
  {
    title: "6. Applicant-Bereich, Bewerbungen, Profile und Nachweisdaten",
    content: (
      <>
        <p>
          Im Applicant-Bereich verarbeiten wir die Daten, die für Profilpflege, Bewerbungsvorbereitung,
          Matching, Kommunikation, Filing-Anforderungen und die weitere Zusammenarbeit mit Experts4Europe
          erforderlich sind.
        </p>
        <ul>
          <li>Stammdaten, Kontaktdaten, Sprach- und Berufsinformationen,</li>
          <li>CV- und Qualifikationsdaten, Berufswege, Berufserfahrung und Wunschangaben,</li>
          <li>Verifikations- und Nachweisdaten, inklusive hochgeladener Dokumente innerhalb der Hauptplattform,</li>
          <li>Kommunikationsverläufe, Statusdaten, Filing-Anfragen, Rückmeldungen und interne Prozessvermerke.</li>
        </ul>
        <p>
          Soweit aus Dokumenten besondere Kategorien personenbezogener Daten hervorgehen können, verarbeiten
          wir diese nur, soweit dies für den jeweiligen Prozess erforderlich ist, Sie die Daten selbst
          bereitstellen oder eine gesonderte gesetzliche Grundlage eingreift. Rechtsgrundlagen sind vor allem
          Art. 6 Abs. 1 lit. b DSGVO sowie - je nach Einzelfall - Art. 9 Abs. 2 DSGVO.
        </p>
      </>
    ),
  },
  {
    title: "7. Employer-Bereich, Stellenanzeigen und Bewerbermanagement",
    content: (
      <>
        <p>
          Im Employer-Bereich verarbeiten wir Daten zur Erstellung und Verwaltung von Stellenanzeigen, zur
          Sichtung von Kandidaten, zur Vorbereitung von Kommunikation, zur Dokumenten- und Filing-Logik
          sowie zur strukturierten Arbeitgeberbetreuung.
        </p>
        <ul>
          <li>Arbeitgeberstammdaten und Ansprechpartner,</li>
          <li>Stellenanzeigen, Anforderungen, Konditionen und interne Bearbeitungsstände,</li>
          <li>bewerbungsbezogene Sichtdaten, Requests, Reminder, Status- und Filing-Informationen,</li>
          <li>interne Notizen, Coach-Kontextinformationen und nachvollziehbare Entscheidungsgrundlagen.</li>
        </ul>
        <p>
          Die Verarbeitung erfolgt zur Vertragsanbahnung und Vertragserfüllung mit Arbeitgebern sowie zur
          geordneten Rekrutierungsdurchführung auf Grundlage von Art. 6 Abs. 1 lit. b und lit. f DSGVO.
        </p>
      </>
    ),
  },
  {
    title: "8. Funnel experts4germany.com",
    content: (
      <>
        <p>
          Über experts4germany.com erfassen wir frühe Interessenten- und Vorqualifizierungsdaten für
          qualifizierte Pflegefachkräfte mit Ziel Deutschland. Der Funnel ist kein Dokumentenportal.
        </p>
        <ul>
          <li>Vor- und Nachname, E-Mail-Adresse, Mobilnummer oder WhatsApp-Kontakt,</li>
          <li>Herkunftsland, Kommunikationssprache, gewünschte Region oder Startzeitpunkt,</li>
          <li>Angaben zu B1, gültigem Reisepass und bestandenem Examen,</li>
          <li>Status- und Funnel-Schrittdaten wie early_signup, eligible_now oder missing_requirement,</li>
          <li>Conversion- und Eventdaten zur Messung der Funnel-Leistung.</li>
        </ul>
        <p>
          Die Verarbeitung erfolgt zur Vorqualifizierung, Frühanmeldung, Follow-up-Steuerung und späteren
          Übergabe in den Hauptprozess von Experts4Europe auf Grundlage von Art. 6 Abs. 1 lit. b und lit. f DSGVO.
        </p>
      </>
    ),
  },
  {
    title: "9. Sprachtests und Audioverarbeitung",
    content: (
      <>
        <p>
          Soweit Sie Sprach- oder Wissenstests innerhalb der Plattform nutzen, verarbeiten wir Ihre Antworten,
          Ergebnisse, Bewertungsdaten und - bei mündlichen Strecken - auch Audioaufnahmen oder daraus erzeugte
          Transkriptions- und Auswertungsdaten.
        </p>
        <p>
          Dies dient der Durchführung des jeweiligen Tests, der Qualifikationsdarstellung, internen
          Qualitätssicherung sowie der anschließenden Einordnung im Bewerbungs- oder Rekrutierungsprozess.
          Rechtsgrundlagen sind Art. 6 Abs. 1 lit. b und lit. f DSGVO.
        </p>
      </>
    ),
  },
  {
    title: "10. KI-gestützte Funktionen und OpenAI",
    content: (
      <>
        <p>
          Experts4Europe setzt an mehreren Stellen KI-gestützte Funktionen ein, zum Beispiel für
          Textvorschläge, Zusammenfassungen, Formulierungshilfen, Coaching, Auswertungen oder die
          sprachliche Unterstützung in Tests und Recruiting-Prozessen.
        </p>
        <p>
          Soweit dies für die jeweilige Funktion erforderlich ist, können Eingaben und der für die
          Funktion nötige Kontext an von uns eingesetzte KI-Dienstleister, derzeit insbesondere OpenAI,
          übermittelt werden. Wir beschränken den Kontext dabei nach dem jeweiligen Anwendungsfall auf das
          funktional Erforderliche.
        </p>
        <p>
          KI-Ausgaben dienen der Unterstützung. Sie ersetzen weder unsere Systeme als Quelle der Wahrheit
          noch eine menschliche Prüfung oder eine verbindliche rechtliche Bewertung. Rechtsgrundlagen sind
          Art. 6 Abs. 1 lit. b und lit. f DSGVO; bei sensiblen Inhalten gilt zusätzlich die jeweils
          einschlägige Sondergrundlage.
        </p>
      </>
    ),
  },
  {
    title: "11. Empfänger und Auftragsverarbeiter",
    content: (
      <>
        <p>
          Wir geben personenbezogene Daten nur weiter, soweit dies für den jeweiligen Zweck erforderlich ist,
          eine gesetzliche Pflicht besteht oder Sie uns eine entsprechende Weisung erteilt haben.
        </p>
        <p>Empfänger können insbesondere sein:</p>
        <ul>
          <li>Hosting- und Infrastruktur-Dienstleister,</li>
          <li>technische Service- und Supportdienstleister,</li>
          <li>KI- und Analyse-Dienstleister für klar begrenzte Funktionszwecke,</li>
          <li>Arbeitgeber, soweit eine konkrete Bewerbungs- oder Matching-Situation dies trägt,</li>
          <li>öffentliche Stellen oder Behörden, soweit dies gesetzlich erforderlich ist.</li>
        </ul>
      </>
    ),
  },
  {
    title: "12. Drittlandübermittlungen",
    content: (
      <>
        <p>
          Soweit wir Dienstleister außerhalb des EWR einsetzen oder Funktionsdaten technisch in ein
          Drittland übermittelt werden, achten wir auf die datenschutzrechtlich erforderlichen Garantien,
          insbesondere Angemessenheitsbeschlüsse oder Standardvertragsklauseln gemäß Art. 44 ff. DSGVO.
        </p>
        <p>
          Bei KI-gestützten Funktionen ist je nach konkret eingesetztem Dienstleister eine Übermittlung in
          Drittländer nicht ausgeschlossen. Wir beschränken Umfang und Zweck der Übermittlung soweit wie möglich.
        </p>
      </>
    ),
  },
  {
    title: "13. Speicherdauer",
    content: (
      <>
        <p>
          Wir speichern personenbezogene Daten nur so lange, wie dies für die jeweiligen Zwecke erforderlich ist
          oder gesetzliche Aufbewahrungspflichten bestehen.
        </p>
        <ul>
          <li>Server- und Sicherheitsprotokolle nur für einen begrenzten, sicherheitsbezogenen Zeitraum,</li>
          <li>Kontodaten grundsätzlich für die Dauer des Nutzungsverhältnisses und anschließender gesetzlicher Pflichten,</li>
          <li>Bewerbungs-, Profil- und Funnel-Daten für die Dauer des jeweiligen Prozesses oder bis zu einer begründeten Inaktivität bzw. Löschanforderung,</li>
          <li>Kommunikations- und Supportdaten so lange, wie dies für Nachvollziehbarkeit, Betreuung und Rechtswahrung erforderlich ist.</li>
        </ul>
      </>
    ),
  },
  {
    title: "14. Datensicherheit",
    content: (
      <p>
        Wir setzen technische und organisatorische Maßnahmen ein, um personenbezogene Daten angemessen gegen
        Verlust, unberechtigte Zugriffe, Manipulation und Missbrauch zu schützen. Dazu gehören insbesondere
        rollenbezogene Zugriffsbeschränkungen, Authentifizierungs- und Sitzungslogik, Protokollierung,
        abgestufte Datenfreigaben sowie eine kontrollierte Trennung von öffentlichen und internen Bereichen.
      </p>
    ),
  },
  {
    title: "15. Ihre Rechte",
    content: (
      <>
        <p>Sie haben im Rahmen der gesetzlichen Voraussetzungen insbesondere folgende Rechte:</p>
        <ul>
          <li>Auskunft über die zu Ihrer Person verarbeiteten Daten,</li>
          <li>Berichtigung unrichtiger oder Vervollständigung unvollständiger Daten,</li>
          <li>Löschung oder Einschränkung der Verarbeitung,</li>
          <li>Widerspruch gegen Verarbeitungen auf Grundlage berechtigter Interessen,</li>
          <li>Datenübertragbarkeit, soweit die Voraussetzungen vorliegen,</li>
          <li>Widerruf einer erteilten Einwilligung mit Wirkung für die Zukunft.</li>
        </ul>
        <p>
          Zur Ausübung Ihrer Rechte genügt eine Nachricht an{" "}
          <a href="mailto:Info@Experts4Europe.com">Info@Experts4Europe.com</a>.
        </p>
      </>
    ),
  },
  {
    title: "16. Beschwerderecht",
    content: (
      <>
        <p>
          Sie haben gemäß Art. 77 DSGVO das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren,
          insbesondere in dem Mitgliedstaat Ihres gewöhnlichen Aufenthalts, Ihres Arbeitsplatzes oder des Orts
          des mutmaßlichen Verstoßes.
        </p>
        <p>
          Aufgrund unseres aktuellen Sitzes kommt insbesondere die österreichische Datenschutzbehörde in
          Betracht:{" "}
          <a href="https://www.dsb.gv.at" target="_blank" rel="noreferrer">
            www.dsb.gv.at
          </a>
          .
        </p>
      </>
    ),
  },
  {
    title: "17. Änderungen dieser Datenschutzerklärung",
    content: (
      <p>
        Wir passen diese Datenschutzerklärung an, wenn sich unsere Dienste, unsere Datenverarbeitungen oder
        die rechtlichen Rahmenbedingungen ändern. Es gilt jeweils die auf dieser Seite veröffentlichte Fassung.
      </p>
    ),
  },
];

export default function Datenschutz() {
  const navigate = useNavigate();

  const hero = (
    <section className="public-legal-hero">
      <CContainer fluid className="public-core-container public-legal-shell public-page-shell">
        <div className="public-legal-hero__panel public-page-hero-panel">
          <div className="public-legal-hero__copy">
            <span className="public-core-eyebrow public-page-overline">Datenschutz</span>
            <h1 className="public-page-title">Datenschutzerklärung</h1>
            <p className="public-legal-hero__lead public-page-body">
              Diese Datenschutzerklärung ist auf den aktuellen Funktionsumfang von Experts4Europe
              zugeschnitten: öffentliche Website, Funnel, Applicant- und Employer-Bereiche, Dokumenten-
              und Filing-Prozesse, Sprachtests, Kommunikation sowie KI-gestützte Assistenzfunktionen.
            </p>
            <div className="public-legal-chip-row">
              <span>Website</span>
              <span>Funnel</span>
              <span>Applicant</span>
              <span>Employer</span>
              <span>KI-Funktionen</span>
            </div>
          </div>

          <aside className="public-legal-hero__meta">
            <div className="public-legal-callout public-page-callout">
              <strong>Stand</strong>
              <span>{updateDate}</span>
            </div>
            <div className="public-legal-callout public-page-callout">
              <strong>Kontakt Datenschutz</strong>
              <a href="mailto:Info@Experts4Europe.com">Info@Experts4Europe.com</a>
            </div>
            <div className="public-legal-callout public-page-callout">
              <strong>Wichtiger Hinweis</strong>
              <p>
                Diese Fassung ist auf den aktuellen Plattformbetrieb abgestimmt, ersetzt aber
                keine abschließende rechtliche Einzelfallprüfung.
              </p>
            </div>
          </aside>
        </div>
      </CContainer>
    </section>
  );

  return (
    <PublicContentPageShell pageClassName="public-legal-page" hero={hero}>
      <section className="public-core-band public-core-band--neutral">
        <CContainer fluid className="public-core-container public-legal-shell public-page-shell">
          <div className="public-legal-card public-page-card">
            <span className="public-core-eyebrow public-page-overline">Rechtsgrundlagen</span>
            <h2>Worauf wir die Verarbeitung stützen</h2>
            <div className="public-legal-basis-grid">
              {legalBasisItems.map((item) => (
                <article key={item.title} className="public-legal-basis-card public-page-value-card">
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </article>
              ))}
            </div>
          </div>
        </CContainer>
      </section>

      <section className="public-core-band public-core-band--light">
        <CContainer fluid className="public-core-container public-legal-shell public-page-shell">
          <div className="public-legal-card public-page-card">
            <span className="public-core-eyebrow public-page-overline">Struktur</span>
            <h2 className="public-page-subtitle">Alle Datenschutzabschnitte ruhig und lesbar im Überblick</h2>
            <p className="public-page-body public-page-body--muted">
              Die Erklärung bleibt inhaltlich vollständig, ist aber für die öffentliche Leseführung
              jetzt über eine klare Accordion-Struktur gegliedert.
            </p>
          </div>

          <CAccordion alwaysOpen className="public-privacy-accordion">
            {sections.map((section, index) => (
              <CAccordionItem key={section.title} itemKey={index + 1}>
                <CAccordionHeader>{section.title}</CAccordionHeader>
                <CAccordionBody>
                  <div className="public-legal-richtext public-page-richtext">{section.content}</div>
                </CAccordionBody>
              </CAccordionItem>
            ))}
          </CAccordion>

          <div className="public-legal-nav public-page-card">
            <div className="public-legal-nav__copy">
              <span className="public-core-eyebrow public-page-overline">Rechtliche Seiten</span>
              <h2 className="public-page-subtitle">Impressum und AGB direkt im selben Public-Standard</h2>
              <p className="public-page-body public-page-body--muted">
                Rechtliche Pflichtseiten bleiben ohne Sonderwelt und mit derselben Header-, Footer-
                und Leselogik erreichbar.
              </p>
            </div>
            <div className="public-legal-nav__actions">
              <CButton type="button" className="public-core-btn public-core-btn--subtle" onClick={() => navigate("/impressum")}>
                Impressum
              </CButton>
              <CButton type="button" className="public-core-btn public-core-btn--ghost" onClick={() => navigate("/agb")}>
                AGB
              </CButton>
            </div>
          </div>
        </CContainer>
      </section>
    </PublicContentPageShell>
  );
}
